export interface DoctorChoice {
  id: string;
  name: string;
  departmentId?: string | null;
  departments?: { id: string; name: string }[];
}

export interface ScheduleAccess {
  involved: boolean;
  onlyOwn: boolean;
  mayManageFor: (doctorId: string) => boolean;
}

export function scheduleAccess(held: { all: boolean; own: boolean }, userId: string | null): ScheduleAccess {
  return {
    involved: held.all || held.own,
    onlyOwn: held.own && !held.all,
    mayManageFor: (doctorId) => held.all || (held.own && userId !== null && doctorId === userId),
  };
}

export function selectableDoctors<T extends DoctorChoice>(access: ScheduleAccess, doctors: T[], self: T | null): T[] {
  if (!access.onlyOwn) return doctors;
  if (!self) return [];
  return [doctors.find((doctor) => doctor.id === self.id) ?? self];
}
